module.exports = __webpack_public_path__ + "static/images/ico-radio@2x.fa7d460.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/edit/config/ico-radio@2x.png
// module id = zUyU
// module chunks = 6 7